import { useEffect, useState } from "react";
import { opApi } from "@/lib/operator";
import OperatorHeader from "@/components/OperatorHeader";
import { Loader2, Tractor, Radio } from "lucide-react";

export default function OperatorMachines() {
  const [data, setData] = useState({ data: [], source: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    opApi.get("/app/machines")
      .then(r => setData(r.data || { data: [] }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 pb-12">
      <OperatorHeader back="/app" title="Machines" />
      <div className="px-4 sm:px-6 py-5 max-w-3xl mx-auto">
        {loading ? (
          <div className="text-slate-500 text-sm flex items-center gap-2"><Loader2 className="animate-spin" size={14} /> Loading…</div>
        ) : !data.data.length ? (
          <div className="bg-white border-2 border-dashed border-slate-200 rounded-xl p-8 text-center">
            <Tractor size={32} className="mx-auto text-slate-300 mb-2" />
            <div className="text-slate-500 text-sm">No machines available.</div>
          </div>
        ) : (
          <ul className="space-y-2">
            {data.data.map(m => (
              <li key={m.vin} className="bg-white border border-slate-200 rounded-xl px-5 py-4 flex items-center gap-4 shadow-sm">
                <div className="w-12 h-12 rounded-lg bg-[#1a1a5c] grid place-items-center shrink-0">
                  <Tractor size={22} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-[#1a1a5c]">{m.label || m.vin}</div>
                  <div className="text-xs text-slate-500">{m.model}</div>
                </div>
                {m.source === "live" ? (
                  <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded">
                    <Radio size={10} /> Live
                  </span>
                ) : (
                  <span className="text-[10px] uppercase tracking-widest font-bold text-slate-400">Manual</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
